import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getTodayEvents = ({ churchId }) => {
  return axios.get(`/churches/${churchId}/today-events`);
};

export const useTodayEvents = ({ churchId, config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ["today-events", churchId],
    queryFn: () => getTodayEvents({ churchId }),
    select: data => data.result
  });
};
